"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workspace_1 = require("./workspace");
var WORKSPACE_LOCALSTORAGE_KEY = "workspace";
var LocalWorkspaceRepository = /** @class */ (function () {
    function LocalWorkspaceRepository() {
    }
    LocalWorkspaceRepository.prototype.getOrCreate = function () {
        var workspace = this.get();
        if (!workspace) {
            workspace = new workspace_1.Workspace({
                id: "",
                name: "",
                windows: [],
                eikonInstanceId: "",
                eikonWorkspace: { data: JSON.stringify({}) },
                rediPlusWindows: JSON.stringify([])
            });
            this.set(workspace);
        }
        return workspace;
    };
    LocalWorkspaceRepository.prototype.get = function () {
        var workspaceAsJson = window.localStorage.getItem(WORKSPACE_LOCALSTORAGE_KEY);
        if (workspaceAsJson) {
            try {
                var serverModel = JSON.parse(workspaceAsJson);
                return new workspace_1.Workspace(serverModel);
            }
            catch (error) {
                console.log("Error in getting workspace from storage:", error);
                return null;
            }
        }
        return null;
    };
    LocalWorkspaceRepository.prototype.set = function (workspace) {
        var json = JSON.stringify(workspace.serverModel());
        window.localStorage.setItem(WORKSPACE_LOCALSTORAGE_KEY, json);
    };
    LocalWorkspaceRepository.prototype.update = function (updater) {
        var workspace = this.getOrCreate();
        var result = updater(workspace);
        this.set(workspace);
        return result;
    };
    LocalWorkspaceRepository.prototype.clear = function () {
        window.localStorage.removeItem(WORKSPACE_LOCALSTORAGE_KEY);
    };
    return LocalWorkspaceRepository;
}());
exports.LocalWorkspaceRepository = LocalWorkspaceRepository;
exports.localWorkspaceRepository = new LocalWorkspaceRepository();



//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib/dist/business/local-workspace-repository.js
// module id = 135
// module chunks = 0